import { useState } from "react";

interface StoreLogoProps {
  src?: string;
  alt?: string;
  title?: string;
  className?: string;
}

const imgStyle: React.CSSProperties = {
  width: "auto",
  height: "auto",
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
};

const StoreLogo = ({
  src,
  alt = "Store logo",
  title,
  className = "",
}: StoreLogoProps) => {
  const [failed, setFailed] = useState(false);
  const initial = (title || alt).trim().charAt(0).toUpperCase() || "A";

  if (!src || failed) {
    return (
      <div
        aria-label={alt}
        role="img"
        className={`inline-flex aspect-square shrink-0 items-center justify-center overflow-hidden rounded-xl bg-gradient-to-br from-gray-800 via-gray-700 to-gray-500 text-white select-none [container-type:size] ${className}`}
      >
        <span className="text-[50cqh] font-bold leading-none">{initial}</span>
      </div>
    );
  }

  return (
    <span
      className={`inline-flex shrink-0 overflow-hidden rounded-xl ${className}`}
    >
      <img
        src={src}
        alt={alt}
        loading="eager"
        decoding="async"
        fetchPriority="high"
        draggable={false}
        onError={() => setFailed(true)}
        style={imgStyle}
      />
    </span>
  );
};

export default StoreLogo;
